// Overview disabled — the previous force-graph + matrix render pegged many
// browsers. Re-enable by restoring the tabbed shell (Matrix / Temporal /
// Explore) once the rendering perf issues are addressed.

import React from 'react';

export default function OverviewPage() {
  return (
    <div className="malpedia-graph-page overview-page">
      <div className="overview-topbar">
        <div className="overview-title">Overview</div>
      </div>
      <div className="overview-empty" style={{ padding: 24 }}>
        The Overview is temporarily disabled while we rework it for performance.
        Use Explore or the entity pages in the meantime.
      </div>
    </div>
  );
}
